import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loader = _resolveComponent("Loader")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["pulse-num", {selected: $props.selected, hoverable: !$props.loading && $props.count}]),
    relative: ""
  }, [
    ($props.loading)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 0,
          mini: ""
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createTextVNode(_toDisplayString($options.c_count), 1 /* TEXT */)
        ], 64 /* STABLE_FRAGMENT */))
  ], 2 /* CLASS */))
}